import "core-js/modules/es.object.to-string.js";
/*
 * Returns a queue function that executes all passed
 * functions with the queue function's arguments
 */
function mergeCallbacks() {
  for (var _len = arguments.length, passedFunctions = new Array(_len), _key = 0; _key < _len; _key++) {
    passedFunctions[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    passedFunctions.forEach(function (func) {
      if (func) func.apply(void 0, args);
    });
  };
}
export default mergeCallbacks;